module.exports = __webpack_public_path__ + "static/img/FITmenu09.d4c114d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu09.png
// module id = 7xDG
// module chunks = 1